import axios from "axios";
import { clearSession } from "./session";
import { API_BASE_URL } from "./apiConfig";

export { API_BASE_URL };

const api = axios.create({
    baseURL: "http://15.252.228.63/api/"
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers = config.headers || {};
        config.headers["x-access-token"] = token;
    }
    return config;
});

let redirecting = false;

const AUTH_PATHS = ["/auth/login", "/auth/verifyotp", "/auth/logout"];

const isAuthRequest = (url?: string): boolean =>
    !!url && AUTH_PATHS.some((path) => url.includes(path));

api.interceptors.response.use(
    (res) => res,
    (err) => {
        const isSessionDead =
            err?.response?.status === 401 && !isAuthRequest(err?.config?.url);

        if (isSessionDead && !redirecting) {
            redirecting = true;
            clearSession();
            window.location.replace("/");
        }
        return Promise.reject(err);
    }
);

export default api;
